/*eslint-disable */

import React, { useState, useContext, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import RedeemService from "../services/Redeem.service"; // Adjust import as per your project structure
import Skeleton from "react-loading-skeleton"; // If you are using this for loading states
import { UserContext } from "../hooks/UserContext"; // Adjust import as per your project structure
import ClipboardCopy from "../components/ClipboardCopy"; // Adjust import as per your project structure
import AnimatedNumbers from "react-animated-numbers";
import { Dropdown, Modal as MModal, Nav, Tab } from "react-bootstrap";
import "./redeem.css";
import { FailedNotification } from "../components/Notifications";

import fernet from "fernet";

import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";

import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
} from "@material-ui/icons";
import { ToastContext } from "../hooks/ToastContext";

import myBackground from "../assets/img/GC_logo_new-01.png";
import moment from "moment-timezone";

// Load or generate your secret key (ensure this matches the key used in Python)
const secretKey = process.env.REACT_APP_PINELABS_ENCRYPTION_KEY; // Use .env for storing the secret key
const fernetKey = new fernet.Secret(secretKey); // Create a Fernet key instance

function HistoryV2() {
  const { handleToastState } = useContext(ToastContext);

  const showToast = () => {
    handleToastState(true); // Set toast as active
    // Logic to display the toast
  };

  const dismissToast = () => {
    handleToastState(false); // Set toast as inactive
    // Logic to dismiss the toast
  };

  const [isLoading, setIsLoading] = useState(false);

  const [redeemLoading, setRedeemLoading] = useState(false);

  const [MyPoints, setMyPoints] = useState({
    totalReward: 0,
    totalRemaining: 0,
  });

  // const fetchData2 = async () => {
  //   setIsLoading(true);

  //   RedeemService.getPoints()
  //     .then((response) => {
  //       console.log("json3:", response.data);
  //       setMyPoints(response.data);
  //     })
  //     .catch((error) => {
  //       console.error(error.message);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };
  // useEffect(() => {
  //   if (redeemLoading === false) {
  //     fetchData2();
  //   }
  // }, [redeemLoading]);

  const [modal, setModal] = useState(false);
  const [skuDetails, setSkuDetails] = useState(null);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);

  const [dynamicKey, setDynamicKey] = useState("");

  const [toggleSpinner, settoggleSpinner] = useState(false);

  const [focusedIndex, setFocusedIndex] = useState(null);

  const handleClose = () => {
    settoggleSpinner(false);
    setFocusedIndex(null);
    setModal((current) => !current);
    setSelectedItem(null);
    setDynamicKey("");
  };

  function getBallClass(status) {
    const statusColors = {
      PENDING: "orange", // Orange
      PROCESSING: "blue", // Blue
      CANCELLED: "red", // Red
      winner: "gold", // Gold
      participation: "gray", // Gray
      COMPLETE: "green", // Green
    };

    return statusColors[status] || "#ff9b44"; // Default to black if status is not recognized
  }

  function getStatusIcon(status) {
    const statusIcons = {
      PENDING: "las la-hourglass-start", // Hourglass start
      PROCESSING: "las la-sync", // Sync
      CANCELLED: "las la-times-circle", // Times circle
      winner: "las la-trophy", // Trophy
      participation: "las la-handshake", // Handshake
      COMPLETE: "las la-check-circle", // Check circle
    };

    return statusIcons[status] || "las la-question-circle"; // Default to question circle if status is not recognized
  }

  const { currentUser } = useContext(UserContext);

  // State variables specific to history
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);
  const [PointHistory, setPointHistory] = useState([]);

  const Options = [
    {
      name: "All",
      search: "ALL",
    },

    {
      name: "Redeemed",
      search: "DB",
    },

    {
      name: "Earned",
      search: "CR",
    },
  ];

  const [optionSelected, setOption] = useState("ALL");

  // const fetchData = async () => {
  //   if (currentUser.role !== undefined) {
  //     RedeemService.getProfileHistory()
  //       .then((response) => {
  //         console.debug("history is been rendered", response);
  //         setPointHistory(response.data.items);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching history:", error.message);
  //       })
  //       .finally(() => {
  //         setIsLoadingHistory(false);
  //       });
  //   }
  // };

  // // Other functions (filterPointHistory, getTimeDifference) go here

  // useEffect(() => {
  //   fetchData();
  // }, [currentUser]);

  // Filter history data based on event type
  const filterPointHistory = (data, eventType) => {
    const filterMapper = {
      1: (item) => true, // Return all items
      2: (item) => item.event_type === "DB", // Return credited items
      3: (item) => item.event_type === "CR", // Return debited items
    };

    return data.filter(filterMapper[eventType] || ((item) => false));
  };

  // Function to calculate time difference
  function getTimeDifference(givenTime) {
    // Get full timezone name
    const timeZoneGuess = moment.tz.guess();

    // Get standard abbreviation
    const timeZoneAbbr = moment.tz(timeZoneGuess).format("z");

    // Automatically detect the full timezone name from the abbreviation
    const detectedTimeZone = moment.tz.zone(timeZoneAbbr)?.name;

    // If the abbreviation is invalid, fallback to UTC
    const timeZone = detectedTimeZone || "UTC";

    // Convert given UTC time to the specified timezone
    const givenDate = moment.utc(givenTime).tz(timeZone);

    // Get the current time in the specified timezone
    const currentTime = moment().tz(timeZone);

    // Calculate the time difference
    const timeDifference = currentTime.diff(givenDate);
    const duration = moment.duration(timeDifference);

    const hoursDifference = Math.floor(duration.asHours());
    const minutesDifference = duration.minutes();
    const secondsDifference = duration.seconds();

    if (timeDifference < 60 * 1000) {
      return `${secondsDifference} seconds ago`;
    }
    if (hoursDifference < 1) {
      return `${Math.abs(minutesDifference)} minutes ago`;
    } else if (hoursDifference < 24) {
      return `${hoursDifference} hours ago`;
    } else if (hoursDifference >= 24 && hoursDifference < 36) {
      return "Yesterday";
    } else {
      // Return formatted date
      return givenDate.format("YYYY-MM-DD");
    }
  }

  function getContrastingTextColor(hexColor) {
    // Convert hex color to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // Calculate brightness (YIQ formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // Return black for bright colors, white for dark colors
    return brightness > 128 ? "#000000" : "#FFFFFF";
  }

  // Function to decrypt JSON data
  const decryptJson = (encryptedData) => {
    if (encryptedData) {
      // Decode the base64 encoded string
      const decodedData = Buffer.from(encryptedData, "base64");

      // Decrypt the data
      const fernetToken = new fernet.Token({
        token: decodedData.toString("utf-8"),
        secret: fernetKey,
        ttl: 0, // Set to 0 to indicate no expiration
      });

      try {
        const decryptedData = fernetToken.decode();
        // Parse the decrypted JSON string back to an object
        return JSON.parse(decryptedData);
      } catch (error) {
        console.error("Decryption failed:", error);
        return null;
      }
    }
    return null;
  };

  const handleShow = (index, each) => {
    console.log("open modal", each["coupon"]);
    setFocusedIndex(index);
    setModal((current) => !current);

    const decrypted = decryptJson(each["coupon"]);
    console.log("decrypted: ", decrypted);
    setSelectedItem(decrypted);
    setSkuDetails(each);

    let temkey =
      (decrypted?.products && Object.keys(decrypted?.products)[0]) || undefined; // Dynamically get the first key (like CNPIN or any other word)

    setDynamicKey(temkey);
  };

  const [searchText, setSearchText] = useState("ALL");

  const handleTextChange = (text) => {
    setValue(text);
  };
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);

  const [showecards, setShowecards] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [totalItems, setTotalItems] = useState(0); // Add state for total items

  const fetchDataHistory = async () => {
    if (currentUser.role !== undefined) {
      setIsLoading(true);
      try {
        const response = await RedeemService.getProfileHistory(
          currentUser.id,
          page + 1,
          rowsPerPage,
          searchText
        );
        setPointHistory(response.data.items);
        console.debug("debug products:", response.data.items);
        setTotalItems(response.data.total);
        // setWasLastList(response.data.items.length < pageSize);
      } catch (error) {
        console.error("Error fetching banners:", error);

        if (error.response) {
          // The request was made and the server responded with a status code >= 400
          console.error("Error:", error.response.data);
          console.error("Status Code:", error.response.status);
          // FailedNotification(error.response.data.detail, showToast, dismissToast);
        } else if (error.request) {
          // The request was made but no response was received
          console.error("No response received:", error.request);
        } else {
          // Something else happened while setting up the request
          console.error("Error:", error.message);
          FailedNotification(error.message, showToast, dismissToast);
        }
      } finally {
        setIsLoading(false);
        setIsLoadingHistory(false);
      }
    }
  };

  useEffect(() => {
    if (!showecards) {
      fetchDataHistory();
    }
  }, [page, showecards, searchText, rowsPerPage, modal, currentUser]);

  const tableIcons = {
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
  };

  const handleChangePage = (event, newPage) => {
    console.log("handleChangePage: ", newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div style={{ height: "100vh" }}>
      <MModal
        show={modal}
        onHide={handleClose}
        // backdrop="static"
        keyboard={false}
        className="modal-right-wider"
        // style={{
        //   zIndex: 9999,
        // }}
      >
        <div className="modal-header ">
          <h4 style={{ color: "#f58b29" }}>
            {selectedItem?.products?.[dynamicKey]?.name || skuDetails?.message}
          </h4>

          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {selectedItem?.products?.[dynamicKey]?.name !== undefined ? (
            <div
              style={{
                paddingTop: "4%",
                paddingBottom: "1%",
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${myBackground})`,
                  width: "270px",
                  height: "150px",
                  borderRadius: "20px",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "20px",
                  border: "1px solid #000",
                }}
              ></div>
              <h2
                className="mt-4 mb-4"
                style={{ color: "#f58b29", textAlign: "left", width: "100%" }}
              >
                <span>
                  INR:
                  {selectedItem?.cards[0]?.amount}
                </span>
              </h2>
              {["CNPIN", "CLAIMCODE", "testsuccess001", "EGCGBESP001"].includes(
                dynamicKey
              ) && (
                <>
                  <ClipboardCopy
                    title={"Card Number :"}
                    copyText={selectedItem?.cards[0]?.cardNumber}
                  />

                  <ClipboardCopy
                    title={"Card Pin :"}
                    copyText={selectedItem?.cards[0]?.cardPin}
                  />
                </>
              )}

              {dynamicKey === "UBEFLOW" && (
                <>
                  <ClipboardCopy
                    title={"Card Number :"}
                    copyText={selectedItem?.cards[0]?.cardNumber}
                  />

                  <ClipboardCopy
                    title={"URL :"}
                    copyText={
                      <a
                        target="_blank"
                        href={selectedItem?.cards[0]?.activationUrl}
                      >
                        {"GiftCard"}
                      </a>
                    }
                  />
                </>
              )}

              {["VOUCHERCODE"].includes(dynamicKey) && (
                <>
                  <ClipboardCopy
                    title={"Voucher Code :"}
                    copyText={selectedItem?.cards[0]?.cardPin}
                  />
                </>
              )}
              <p className="mt-4">
                <strong className="mr-2">
                  <span style={{ color: "red", marginRight: 2 }}>*</span>Valid
                  Till :
                </strong>

                {new Date(selectedItem?.cards[0]?.validity).toLocaleDateString(
                  "en-IN",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </p>
              <h2
                className="mt-4"
                style={{ color: "#f58b29", textAlign: "left", width: "100%" }}
              >
                HOW TO REDEEM?
              </h2>
              <ul
                style={{
                  color: "#f58b29",
                  paddingLeft: "20px",
                  lineHeight: "1.6",
                }}
              >
                {["VOUCHERCODE"].includes(dynamicKey) && (
                  <>
                    <li>
                      Visit{" "}
                      <a target="_blank" href="https://www.amazon.in/vouchers">
                        www.amazon.in/vouchers
                      </a>
                    </li>
                    <li>
                      Enter the voucher code in 'Add new' section. Click on 'Add
                      button' to add voucher.
                    </li>
                  </>
                )}

                {[
                  "CNPIN",
                  "CLAIMCODE",
                  "testsuccess001",
                  "EGCGBESP001",
                ].includes(dynamicKey) && (
                  <>
                    <li>
                      To add your GC to your Amazon Pay balance, visit{" "}
                      <a
                        target="_blank"
                        href="https://www.amazon.in/addgiftcard"
                      >
                        amazon.in/addgiftcard
                      </a>
                    </li>
                    <li>
                      Customer can apply the 14 digit code on
                      amazon.in/addgiftcard and add the Gift Card balance in
                      his/her Amazon.in account.
                    </li>
                  </>
                )}

                {["UBEFLOW"].includes(dynamicKey) && (
                  <>
                    <li>
                      To add your GC to your Amazon Pay balance, visit{" "}
                      <a
                        target="_blank"
                        href={selectedItem?.cards[0]?.activationUrl}
                      >
                        here
                      </a>
                      .
                    </li>
                  </>
                )}
              </ul>
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center text-center"
              style={{ height: "100%" }}
            >
              <strong>NO DATA</strong>
            </div>
          )}
        </div>

        <div className="modal-footer text-left">
          <small style={{ color: "#f58b29" }}>
            <strong style={{ color: "grey" }}>OrderId: </strong>
            {`${selectedItem?.orderId ? selectedItem?.orderId : "NOT FOUND"}`}
          </small>
        </div>
      </MModal>

      <div className="page-wrapper" style={{ backgroundColor: "white" }}>
        <div className="content container-fluid">
          {/* Breadcrumb */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title"> History</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/home">
                      <span>
                        <i className="la la-home"></i> Home
                      </span>
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <i className="las la-history mr-1"></i>History
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* End of Breadcrumb */}
          {/* <div
            className="row mx-auto mt-5 mb-2 w-75"
            style={{
              minHeight: "150px",
              borderRadius: 20,
              boxShadow: "6px 6px 6px #f0f0f0",
            }}
          >
            <div
              className="col-md-6"
              style={{
                backgroundImage:
                  "linear-gradient(to right, rgb(243, 122, 65), rgb(255 175 46))",
                borderTopLeftRadius: 20,
                borderBottomLeftRadius: 20,
              }}
            >
              <div className="position-relative h-100 text-center d-flex text-white">
                <i className="las la-coins align-icon"></i>
                <h2 className="position-relative m-auto" style={{ zIndex: 1 }}>
                  <AnimatedNumbers
                    includeComma
                    animateToNumber={MyPoints.totalRemaining}
                    locale="en-IN"
                    configs={[
                      { mass: 1, tension: 220, friction: 100 },
                      { mass: 1, tension: 180, friction: 130 },
                      { mass: 1, tension: 280, friction: 90 },
                      { mass: 1, tension: 180, friction: 135 },
                      { mass: 1, tension: 260, friction: 100 },
                      { mass: 1, tension: 210, friction: 180 },
                    ]}
                  ></AnimatedNumbers>
                </h2>
                <p
                  className="position-absolute mb-2"
                  style={{
                    bottom: 0,
                    left: "50%",
                    marginLeft: "-5em",
                    fontSize: 10,
                  }}
                >
                  * Total Points Credited
                </p>
              </div>
            </div>

            <div
              className="col-md-6 d-flex"
              style={{
                backgroundColor: "white",
                borderTopRightRadius: 20,
                borderBottomRightRadius: 20,
                border: "1px solid #ddd",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                className="btn add-btn"
                onClick={() => (window.location.href = "/redeem")}
              >
                Redeem Now <i className="las la-angle-right"></i>
              </button>
            </div>
          </div> */}
          {/* headers started */}
          {/* <div
          className="row  mx-auto align-items-center"
          style={{ marginBottom: 10, marginTop: 10 }}
        >
          <div className="col-md-6">
            <h3>Credit History</h3>
          </div>
          <div className="col-md-6 text-right">
            <button className="btn add-btn">
              <i className="las la-filter"></i>
            </button>
          </div>
        </div> */}
          <div className="row mt-5 mb-2">
            <div className="col-md-12 text-right">
              <select
                className="btn  dropdown-toggle"
                style={{
                  borderRadius: 50,
                  width: "20%",
                  borderColor: "#ff9b44",
                  color: "#ff9b44",
                }}
                value={searchText}
                onChange={(e) => {
                  console.log(e.target.value);
                  setSearchText(e.target.value);
                }}
              >
                {Options.map((each) => (
                  <option key={each.search} value={each.search}>
                    {each.name.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div
            className="experience-content mt-5 mb-4 ml-2 mr-0 row"
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              color: "#4c3a2b",
              backgroundColor: "#fff8f2",
              boxShadow: "6px 6px 6px #f0f0f0",
              borderRadius: 6,
            }}
          >
            <div className="col-md-6">
              <h4 className="mb-0 pl-4 py-2">Info</h4>
            </div>
            <div className="col-md-4 ">
              <h4 className="mb-0 pl-4 py-2">Order Status</h4>
            </div>
            <div className="col-md-2 text-center">
              <h4 className="mb-0 pl-0 py-2">Action</h4>
            </div>
          </div>
          {/* headers ended */}
          {/* history started */}
          <div
            className="row mx-auto align-items-center cards-timeline"
            // style={{ width: "80%" }}
          >
            {isLoadingHistory ? (
              <>
                <div className="flex-row  rounded-lg w-100 justify-content-between ">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: "15px",
                        boxShadow: "6px 6px 6px #f0f0f0",
                      }}
                    >
                      <Skeleton height={40} />
                    </div>
                  ))}
                </div>
              </>
            ) : PointHistory.length > 0 ? (
              // Render History Items
              PointHistory.map((each, index) => (
                <Fragment key={index}>
                  <div
                    className={`flex-row p-2 rounded-lg w-100 justify-content-between card card-${getBallClass(
                      each.status
                    )}`}
                    style={{ animationDelay: `${index * 0.2}s` }}
                  >
                    <div className="col-6">
                      <div className="d-flex flex-column">
                        <div className="d-inline-flex flex-row align-items-center">
                          <h4 className="my-auto ml-2 " style={{ width: 400 }}>
                            <i
                              className="las la-coins"
                              style={{
                                color:
                                  each.event_type === "CR" ? "green" : "red",
                              }}
                            ></i>{" "}
                            {each.points.toLocaleString("en-US")}
                          </h4>
                        </div>
                        <div className=" d-inline-flex flex-row align-items-center">
                          <small className="mb-0 ml-2">
                            {getTimeDifference(each.on)}
                          </small>
                          <span className="mx-2 text-muted">|</span>
                          <small>
                            {each.event_type == "CR"
                              ? each.message
                              : `Used points for ${each.message}`}
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* <button className="btn btn-outline-secondary rounded-pill btn-sm">
                      View Details
                    </button> */}

                    {/* <div
                      className="rounded-pill text-center"
                      style={{
                        border: "1px solid #000",
                        width: "100px",
                        height: "32px",
                      }}
                    >
                      show details
                    </div> */}
                    <div className="col-4 d-flex justify-content-start">
                      <div className="d-inline-flex align-items-center">
                        {each.status && (
                          <div
                            className={`badge rounded-pill h6 mb-0`}
                            style={{ marginLeft: 20 }}
                          >
                            <i className={getStatusIcon(each.status)}></i>{" "}
                            {each.status === "COMPLETE"
                              ? "ACTIVATED"
                              : each.status.toUpperCase()}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-2 d-flex justify-content-center">
                      <div className="d-inline-flex align-items-center">
                        {!["winner", "participation"].includes(each.status) ? (
                          <>
                            <button
                              title="Show Details" // Add your tooltip text here
                              className="btn"
                              onClick={() => handleShow(index, each)}
                              style={{
                                padding: "2px 6px",
                                fontSize: "12px",
                                //height: 30,
                                borderRadius: 50,
                                //width: 30,
                                borderColor: "#ff9b44",
                                textAlign: "center", // Centers text horizontally
                              }}
                            >
                              Gift Card Details
                            </button>
                          </>
                        ) : (
                          // <button
                          //   title="Show Details" // Add your tooltip text here
                          //   className="btn"
                          //   onClick={() => handleShow(index, each)}
                          //   style={{
                          //     padding: "2px 3px",
                          //     fontSize: "12px",
                          //     height: 30,
                          //     borderRadius: 50,
                          //     width: 30,
                          //     borderColor: "#ff9b44",
                          //     textAlign: "center", // Centers text horizontally
                          //   }}
                          // >
                          //   <i
                          //     className="las la-info"
                          //     style={{ color: "#ff9b44", fontSize: 20 }}
                          //   ></i>
                          // </button>

                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                </Fragment>
              ))
            ) : (
              // No Items Message
              <div className="col-md-12 text-center mt-3">
                <h4>No items found.</h4>
              </div>
            )}

            {PointHistory.length > 0 && (
              <div
                className="pagination-wrapper"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: "2rem",
                  marginBottom: "1rem",
                }}
              >
                <Fragment>
                  <div className="TablePaginationIntroductionDemo">
                    <table aria-label="custom pagination table">
                      <tfoot>
                        <tr>
                          <TablePagination
                            className="CustomTablePagination"
                            rowsPerPageOptions={[8, 16, 24, 32]}
                            colSpan={3}
                            count={totalItems}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            slotProps={{
                              select: {
                                "aria-label": "Rows per page",
                              },
                              actions: {
                                showFirstButton: true,
                                showLastButton: true,
                                slots: {
                                  firstPageIcon: tableIcons.FirstPage,
                                  lastPageIcon: tableIcons.LastPage,
                                  nextPageIcon: tableIcons.NextPage,
                                  backPageIcon: tableIcons.PreviousPage,
                                },
                              },
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <Styles />
                </Fragment>
              </div>
            )}

            {/* <div className="flex-row p-2 rounded-lg w-100 mb-0 box-shadow-none justify-content-between card">
            <div className="d-flex flex-column">
              <div className="d-inline-flex flex-row align-items-center">
                <div className="badge badge-primary rounded-pill h6 mb-0">
                  <i className="las la-arrow-up"></i> In-Process
                </div>
                <h4 className="my-auto ml-2">
                  <i className="las la-rupee-sign"></i> 500
                </h4>
              </div>
              <div className=" d-inline-flex flex-row align-items-center">
                <small className="mb-0">21-07-2025</small>
                <span className="mx-2 text-muted">|</span>
                <small>InvoiceID 112TXN02</small>
              </div>
            </div>
            <div className="badge">
              <button className="btn btn-outline-secondary rounded-pill">
                View Details
              </button>
            </div>
          </div> */}
            {/* <div className="card w-100 overflow-hidden">
            <div className="card-content">
              <div className="card-body cleartfix">
                <div className="media align-items-stretch">
                  <div className="align-self-center">
                    <i className="las la-user-tie primary display-4 mr-2"></i>
                  </div>
                  <div className="media-body">
                    <h4 className="mt-auto mb-0">Credited by</h4>
                    <span>Hemanth Angajala</span>
                  </div>
                  <div className="align-self-center">
                    <span>Remark</span>
                    <h4 className="my-auto">Gain Points</h4>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          </div>
          {/* history ended */}
        </div>
      </div>
    </div>
  );
}

export default HistoryV2;

const cyan = {
  50: "#E9F8FC",
  100: "#BDEBF4",
  200: "#99D8E5",
  300: "#66BACC",
  400: "#1F94AD",
  500: "#0D5463",
  600: "#094855",
  700: "#063C47",
  800: "#043039",
  900: "#022127",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

function Styles() {
  // Replace this with your app logic for determining dark mode

  return (
    <style>
      {`
      .TablePaginationIntroductionDemo {
        width: 500px;
        max-width: 100%;
      }

      th {
        background-color: "#fff"};
      }

      .TablePaginationIntroductionDemo table {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 0.875rem;
        width: 100%;
        box-shadow: 0px 4px 16px ${grey[200]};
        background-color:"#fff"};
        border: 1px solid ${grey[200]};
        border-radius: 12px;
        overflow: hidden;
      }

      .TablePaginationIntroductionDemo td,
      .TablePaginationIntroductionDemo th {
        padding: 16px;
      }

      .TablePaginationIntroductionDemo th {
        background-color: ${"#fff"};
      }

      .CustomTablePagination .${classes.spacer} {
        display: none;
      }

      .CustomTablePagination .${classes.toolbar}  {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;

        @media (min-width: 768px) {
          flex-direction: row;
          align-items: center;
        }
      }

      .CustomTablePagination .${classes.selectLabel} {
        margin: 0;
      }

      .CustomTablePagination .${classes.select} {
        font-family: 'IBM Plex Sans', sans-serif;
        padding: 2px 0 2px 4px;
        border: 1px solid ${grey[200]};
        border-radius: 6px;
        background-color: transparent;
        color: ${grey[900]};
        transition: all 100ms ease;
      }

      .CustomTablePagination .${classes.select}:hover {
        background-color: ${grey[50]};
        border-color: ${grey[300]};
      }

      .CustomTablePagination .${classes.select}:focus {
        outline: 3px solid ${cyan[200]};
        border-color: ${cyan[500]};
      }

      .CustomTablePagination .${classes.displayedRows} {
        margin: 0;

        @media (min-width: 768px) {
          margin-left: auto;
        }
      }

      .CustomTablePagination .${classes.actions} {
        display: flex;
        gap: 6px;
        border: transparent;
        text-align: center;
      }

      .CustomTablePagination .${classes.actions} > button {
        display: flex;
        align-items: center;
        padding: 0;
        border: transparent;
        border-radius: 50%;
        background-color: transparent;
        border: 1px solid ${grey[200]};
        color: ${grey[900]};
        transition: all 120ms ease;

        > svg {
          font-size: 22px;
        }
      }

      .CustomTablePagination .${classes.actions} > button:hover {
        background-color: ${grey[50]};
        border-color: ${grey[300]};
      }

      .CustomTablePagination .${classes.actions} > button:focus {
        outline: 3px solid ${cyan[200]};
        border-color: ${cyan[500]};
      }

      .CustomTablePagination .${classes.actions} > button:disabled {
        opacity: 0.3;
      }

      .CustomTablePagination .${classes.actions} > button:disabled:hover {
        border: 1px solid ${grey[200]};
        background-color: transparent;
      }
      `}
    </style>
  );
}
